import React from "react";
import { StakeAndMint as CrucibleStakeAndMint } from "./StakeAndMintCard";
import CrucibleFeeCard from "../common/CrucibleFeeCard";
import {
  FContainer,
} from "ferrum-design-system";
import { CrucibleMyBalance } from "../../../common/CardMyBalance";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/rootReducer";

export const StakingMint = () => {  
  const { theme } = useSelector((state: RootState) => state.config);
  return (
    <FContainer className="justify_start align_start d-flex min-100vw card-manage new-design-container-paddings-lr">
      <div className="custom-mr-50">
        <CrucibleStakeAndMint />
        {!theme.crucibleConfig?.isCustomClaimEnabled && <CrucibleFeeCard /> }
      </div>
      <div>
        <CrucibleMyBalance />
      </div>
    </FContainer>
  );
};
